import React from "react";
import styled from "styled-components";
import QRIMG from "../../img/QR.png"

const Styled={
    Wrap:styled.div`
        width:100%;
        height:100%;
        display:flex;
        justify-content:center;
        align-items:center;
        flex-direction:column;
    `,
    IMGS:styled.img`
        width:595px;
        height:842px;
    `,
}
const PCWEB=()=>{
    return(
        <Styled.Wrap>
            <Styled.IMGS src={QRIMG}/>
        </Styled.Wrap>
    )
}
export default PCWEB